<template>
    <el-form label-position="left" label-width="150px">
        <el-form-item label="จังหวัด" label-width="100px">
            <div style="display: flex; align-items: center;" label-width="200px">
                <el-select
                v-model="zipcodeAddress.province"
                reserve-keyword
                filterable
                placeholder="กรุณาเลือกจังหวัด"
                :loading="provicneLoading"
                style="width: 88%;"
                @focus="fetchProvince('')"
                @change="fetchProvince(''), selectAddressValue('province')">
                <el-option
                    v-for="item in provinceArray"
                    :key="item.provinceId"
                    :label="item.provinceName"
                    :value="item.provinceName"
                    autocomplete="off"
                    >
                </el-option>
            </el-select>
            <i v-if="isLoadingIcon" class="el-icon-loading" style=" color:rgb(8, 167, 163);font-weight: bold;font-size: 26px; width: 12%;"></i>
            <i v-if="!isProvinceInvalid && !isLoadingIcon" class="el-icon-close" style="padding-left: 5px; color:red;font-weight: bold;font-size: 26px; width: 12%;"></i>
            <i v-if="isProvinceInvalid && !isLoadingIcon"  class="el-icon-check" style="padding-left: 5px; color:green;font-weight: bold;font-size: 26px; width: 12%;"></i>
            </div>
        </el-form-item>
        <el-form-item label="อำเภอ" label-width="100px">
            <div style="display: flex; align-items: center;">
                <el-select
                    v-model="zipcodeAddress.district"
                    filterable
                    placeholder="กรุณาเลือกอำเภอ"
                    :loading="districtLoading"
                    style="width: 88%;"
                    label-width="200px"
                    @focus="fetchDistrict()"
                    @change="fetchDistrict(), selectAddressValue('district')">
                    <el-option
                        v-for="item in districtArray"
                        :key="item.districtId"
                        :label="item.districtName"
                        :value="item.districtName">
                    </el-option>
                </el-select>
                <i v-if="isLoadingIcon" class="el-icon-loading" style="color:rgb(8, 167, 163);font-weight: bold;font-size: 26px; width: 12%;"></i>
                <i v-if="!isDistrictInvalid && !isLoadingIcon" class="el-icon-close" style="padding-left: 5px; color:red;font-weight: bold;font-size: 26px; width: 12%;"></i>
                <i v-if="isDistrictInvalid && !isLoadingIcon"  class="el-icon-check" style="padding-left: 5px; color:green;font-weight: bold;font-size: 26px; width: 12%;"></i>
            </div>
        </el-form-item>
        <el-form-item label="ตำบล" label-width="100px">
            <div style="display: flex; align-items: center;">
                <el-select
                    v-model="zipcodeAddress.subdistrict"
                    filterable
                    placeholder="กรุณาเลือกตำบล"
                    :loading="subDistrictLoading"
                    style="width: 88%;"
                    label-width="200px"
                    @focus="fetchSubDistrict()"
                    @change="fetchSubDistrict(), selectAddressValue('subdistrict')">
                    <el-option
                        v-for="item in subdistrictArray"
                        :key="item.subDistrictId"
                        :label="item.subDistrictName"
                        :value="item.subDistrictName">
                    </el-option>
                </el-select>
                <i v-if="isLoadingIcon" class="el-icon-loading" style="color:rgb(8, 167, 163);font-weight: bold;font-size: 26px; width: 12%;"></i>
                <i v-if="!isSubDistrictInvalid && !isLoadingIcon" class="el-icon-close" style="padding-left: 5px; color:red;font-weight: bold;font-size: 26px; width: 12%;"></i>
                <i v-if="isSubDistrictInvalid && !isLoadingIcon"  class="el-icon-check" style="padding-left: 5px; color:green;font-weight: bold;font-size: 26px; width: 12%;"></i>
            </div>
        </el-form-item>
        <el-form-item label="รหัสไปรษณีย์" label-width="100px">
            <div style="display: flex; align-items: center;">
                <el-select
                    v-model="zipcodeAddress.zipcode"
                    filterable
                    placeholder="กรุณาเลือกรหัสไปรษณีย์"
                    :loading="zipcodeLoading"
                    style="width: 88%;"
                    label-width="200px"
                    @focus="fetchZipcode()"
                    @change="fetchZipcode(), selectAddressValue('zipcode')"
                    @blur="verifyAddressInfo()">
                    <el-option
                        v-for="item in zipcodeArray"
                        :key="item.zipcodeId"
                        :label="item.detail"
                        :value="item.detail">
                    </el-option>
                </el-select>
                <i v-if="isLoadingIcon" class="el-icon-loading" style="color:rgb(8, 167, 163);font-weight: bold;font-size: 26px; width: 12%;"></i>
                <i v-if="!isZipcodeInvalid && !isLoadingIcon" class="el-icon-close" style="padding-left: 5px; color:red;font-weight: bold;font-size: 26px; width: 12%;"></i>
                <i v-if="isZipcodeInvalid && !isLoadingIcon"  class="el-icon-check" style="padding-left: 5px; color:green;font-weight: bold;font-size: 26px; width: 12%;"></i>
            </div>
        </el-form-item>
    </el-form>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'AddressZipcodeSystem',
    props: {
        address: {
            type: Object,
            default: () => {
                return {
                    province: '',
                    district: '',
                    subdistrict: '',
                    zipcode: ''
                }
            }
        },
        invalidAddress: {
            type: Object,
            default: () => {
                return {
                    status: false,
                    dialogShow: false
                }
            }
        }
    },
    data () {
        return {
            loading: false,
            zipcodeAddress: {
                province: '',
                district: '',
                subdistrict: '',
                zipcode: ''
            },
            provicneLoading: false,
            districtLoading: false,
            subDistrictLoading: false,
            zipcodeLoading: false,
            provinceArray: [],
            districtArray: [],
            subdistrictArray: [],
            zipcodeArray: [],
            provinceId: '',
            districtId: '',
            subDistrictId: '',
            isLoadingIcon: false,
            isProvinceInvalid: false,
            isDistrictInvalid: false,
            isSubDistrictInvalid: false,
            isZipcodeInvalid: false
        }
    },
    computed: {
        isDisabledSaveButton () {
            if (this.isProvinceInvalid && this.isDistrictInvalid && this.isSubDistrictInvalid && this.isZipcodeInvalid) {
                return false
            } else {
                return true
            }
        }
    },
    watch: {
        'invalidAddress.dialogShow': {
            immediate: true,
            async handler (show) {
                if (show) {
                    this.zipcodeAddress.province = this.address.province
                    this.zipcodeAddress.district = this.address.district
                    this.zipcodeAddress.subdistrict = this.address.subdistrict
                    this.zipcodeAddress.zipcode = this.address.zipcode
                    this.verifyAddressInfo()
                    await this.fetchProvince(this.address.province)
                    await this.fetchDistrict()
                    await this.fetchSubDistrict()
                    await this.fetchZipcode()
                } else {
                    this.zipcodeAddress.province = ''
                    this.zipcodeAddress.district = ''
                    this.zipcodeAddress.subdistrict = ''
                    this.zipcodeAddress.zipcode = ''
                }
            }
        },
        'address.province': {
            immediate: true,
            async handler (province) {
                this.zipcodeAddress.province = province
                await this.fetchProvince(province)
                await this.fetchDistrict()
                await this.fetchSubDistrict()
                await this.fetchZipcode()
            }
        },
        'address.zipcode': {
            immediate: true,
            handler (zipcode) {
                this.zipcodeAddress.zipcode = zipcode
                this.verifyAddressInfo()
            }
        },
        'address.district': {
            immediate: true,
            handler (district) {
                this.zipcodeAddress.district = district
            }
        },
        'address.subdistrict': {
            immediate: true,
            handler (subdistrict) {
                this.zipcodeAddress.subdistrict = subdistrict
            }
        }
    },
    methods: {
        async fetchProvince (province) {
            this.provicneLoading = true
            try {
                let paramProv = {
                    search: province
                }
                let resProv = await fgApi.order.searchProvince(paramProv)
                if (resProv.success) {
                    this.provinceArray = resProv.data.provinces
                    this.provinceArray.sort((a, b) => {
                        return a.provinceId - b.provinceId
                    })
                    // console.log('province', this.provinceArray)
                } else {
                    this.provinceArray = []
                    this.$message.error('Get province not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
            this.provicneLoading = false
        },
        async fetchDistrict () {
            this.districtLoading = true
            try {
                this.provinceId = this.provinceArray.filter(e => { return e.provinceName === this.zipcodeAddress.province }).map(e => {
                    return e.provinceId
                })[0]
                let paramDist = {
                    province_id: this.provinceId
                }
                // console.log(paramDist)
                let resDist = await fgApi.order.searchDistrict(paramDist)
                // console.log(resDist.data)
                if (resDist.success) {
                    this.districtArray = resDist.data.districts
                    this.districtArray.sort((a, b) => {
                        return a.districtId - b.districtId
                    })
                    // console.log('district', this.districtArray)
                } else {
                    this.districtArray = []
                    this.$message.error('Get district not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
            this.districtLoading = false
        },
        async fetchSubDistrict () {
            this.subDistrictLoading = true
            try {
                this.districtId = this.districtArray.filter(e => { return e.districtName === this.zipcodeAddress.district }).map(e => {
                    return e.districtId
                })[0]
                let paramSubDist = {
                    province_id: this.provinceId,
                    district_id: this.districtId
                }
                // console.log(paramSubDist)
                let resSubDist = await fgApi.order.searchSubDistrict(paramSubDist)
                if (resSubDist.success) {
                    this.subdistrictArray = resSubDist.data.subDistricts
                    this.subdistrictArray.sort((a, b) => {
                        return a.subDistrictId - b.subDistrictId
                    })
                    // console.log('subdist', this.subdistrictArray)
                } else {
                    this.subdistrictArray = []
                    this.$message.error('Get sub-district not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
            this.subDistrictLoading = false
        },
        async fetchZipcode () {
            this.zipcodeLoading = true
            try {
                this.subDistrictId = this.subdistrictArray.filter(e => { return e.subDistrictName === this.zipcodeAddress.subdistrict }).map(e => {
                    return e.subDistrictId
                })[0]
                let paramZip = {
                    province_id: this.provinceId,
                    district_id: this.districtId,
                    subDistrict_id: this.subDistrictId
                }
                // console.log(paramZip)
                let resZip = await fgApi.order.searchZipcode(paramZip)
                if (resZip.success) {
                    this.zipcodeArray = resZip.data.zipcode
                    this.zipcodeArray.sort((a, b) => {
                        return a.zipcodeId - b.zipcodeId
                    })
                    // console.log('zipcode', this.zipcodeArray)
                } else {
                    this.$message.error('Get zipcode not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
            this.zipcodeLoading = false
        },
        selectAddressValue (item) {
            // this.verifyAddressInfo()
            switch (item) {
            case 'province':
                this.address.province = this.zipcodeAddress.province
                this.zipcodeAddress.zipcode = ''
                this.zipcodeAddress.district = ''
                this.zipcodeAddress.subdistrict = ''
                break
            case 'district':
                this.address.district = this.zipcodeAddress.district
                this.zipcodeAddress.zipcode = ''
                this.zipcodeAddress.subdistrict = ''
                break
            case 'subdistrict':
                this.address.subdistrict = this.zipcodeAddress.subdistrict
                this.zipcodeAddress.zipcode = ''
                break
            case 'zipcode':
                this.address.zipcode = this.zipcodeAddress.zipcode
                break
            default:
                break
            }
        },
        async verifyAddressInfo () {
            this.isLoadingIcon = true
            let param = {
                data: [{
                    order_number: this.address.order_number,
                    address: {
                        zipcode: this.address.zipcode,
                        province: this.address.province,
                        district: this.address.district,
                        sub_district: this.address.subdistrict
                    }
                }]
            }
            let verifyAddress = await fgApi.order.verifyAddress(param)
            for (let key in verifyAddress.data) {
                let element = verifyAddress.data[key]
                this.isZipcodeInvalid = element.zipcode
                this.isSubDistrictInvalid = element.subDistrict
                this.isDistrictInvalid = element.district
                this.isProvinceInvalid = element.province
            }
            this.invalidAddress.status = this.isDisabledSaveButton
            // console.log('STATUS:', this.invalidAddress.status)
            this.isLoadingIcon = false
        }
    }
}
</script>
